import { useLingui } from '@lingui/react';
import { CheveronRightIcon } from '@wkda/icons';
import { Button } from '@wkda/styleguide';
import cx from 'classnames';
import { useCallback, useEffect } from 'react';
import { useCarleadDataLayer } from '../../../hooks/useCarleadDataLayer';
import { BenefitsList } from './BenefitsList';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function L2ASelfEvaluationSteps(_ref) {
  let {
    carleadHash,
    marketingExperiment,
    selfInspection
  } = _ref;
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  const dataLayer = useCarleadDataLayer();
  const noImageSelfEvaluation = marketingExperiment?.noImageSelfEvaFunnel === 1;
  const selfEvaluationStep = selfInspection?.step ?? 0;
  const {
    i18n: _i18n
  } = useLingui();
  const stepDataLayer = noImageSelfEvaluation ? `${selfEvaluationStep}-vin` : String(selfEvaluationStep);
  const title = _i18n._(['carleadCreation.l2aSelfEvaluationStepsRCB.titleLanded', 'carleadCreation.l2aSelfEvaluationStepsRCB.titleStep1completed', 'carleadCreation.l2aSelfEvaluationStepsRCB.titleStep2completed', 'carleadCreation.l2aSelfEvaluationStepsRCB.titleStep3completed'][selfEvaluationStep]);
  const cta = _i18n._(['carleadCreation.l2aSelfEvaluationStepsRCB.ctaLanded', 'carleadCreation.l2aSelfEvaluationStepsRCB.ctaStep1completed', noImageSelfEvaluation ? 'carleadCreation.l2aSelfEvaluationStepsRCB.ctaStep2completedNoImage' : 'carleadCreation.l2aSelfEvaluationStepsRCB.ctaStep2completed', 'carleadCreation.l2aSelfEvaluationStepsRCB.ctaStep3completed'][selfEvaluationStep]);
  const steps = ['carleadCreation.l2aSelfEvaluationStepsRCB.step.additionalInformation', 'carleadCreation.l2aSelfEvaluationStepsRCB.step.status', 'carleadCreation.l2aSelfEvaluationStepsRCB.step.photos'];
  const benefitsTranslations = ['carleadCreation.l2aSelfEvaluationStepsRCB.benefitsList.first', 'carleadCreation.l2aSelfEvaluationStepsRCB.benefitsList.second', 'carleadCreation.l2aSelfEvaluationStepsRCB.benefitsList.third'];
  const trackCta = useCallback(e => {
    dataLayer.pushSelfevaBanner(stepDataLayer);
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent(`self-evaluation-step-${stepDataLayer}-completed`, ctaName);
    }
  }, [dataLayer, stepDataLayer, getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  useEffect(() => {
    trackShownEvent(`self-evaluation-step-${stepDataLayer}-completed`);
  }, [stepDataLayer, trackShownEvent]);
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen(`self-evaluation-step-${stepDataLayer}-completed`);
  }, [dataLayer, stepDataLayer]);
  return /*#__PURE__*/_jsx("div", {
    className: "container self-evaluation-steps-rcb",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row justify-content-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-sm-3 d-none d-lg-block",
        children: /*#__PURE__*/_jsx(BenefitsList, {
          classNameRowText: "self-evaluation-steps-rcb__list-item-text",
          benefitsTranslations: benefitsTranslations
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-sm-6 text-center self-evaluation-steps-rcb__col-2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "self-evaluation-steps-rcb__title",
          children: title
        }), /*#__PURE__*/_jsxs(Button, {
          "data-cj-tracking-button-name": "self-evaluation-steps-button",
          component: "a",
          variant: "secondary",
          onClick: trackCta,
          href: `/inspection/${carleadHash}`,
          children: [cta, /*#__PURE__*/_jsx(CheveronRightIcon, {
            className: "ml-2"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "col-sm-3 d-none d-lg-flex align-items-center",
        children: /*#__PURE__*/_jsx("ul", {
          className: "list-unstyled",
          children: steps.map((item, index) => /*#__PURE__*/_jsxs("li", {
            className: "self-evaluation-steps-rcb__steps-item",
            children: [/*#__PURE__*/_jsx("div", {
              className: cx('self-evaluation-steps-rcb__steps-number-wrapper', {
                'self-evaluation-steps-rcb__steps-number-wrapper--completed': selfEvaluationStep > index
              }),
              children: /*#__PURE__*/_jsx("span", {
                className: cx('self-evaluation-steps-rcb__steps-number', {
                  'self-evaluation-steps-rcb__steps-number--active': selfEvaluationStep === index,
                  'self-evaluation-steps-rcb__steps-number--completed': selfEvaluationStep > index
                }),
                children: index + 1
              })
            }), /*#__PURE__*/_jsx("div", {
              className: cx('self-evaluation-steps-rcb__steps-text-wrapper', {
                'self-evaluation-steps-rcb__steps-text-wrapper--active': selfEvaluationStep === index
              }),
              children: /*#__PURE__*/_jsx("p", {
                className: "self-evaluation-steps-rcb__steps-text",
                children: _i18n._(item)
              })
            })]
          }, item))
        })
      })]
    })
  });
}